<template>
  <div class="w-full h-full relative">
    <layout-grid>
      <template #listPanel>
        <panel-list @click="onRoomClick" @plan-click="onPlanClick" />
      </template>

      <template #viewPanel>
        <render-view ref="renderViewRef" v-model="selectedAssets" @progress="progress = $event" @loaded="isLoaded = true" @info="showInfo" />
      </template>

      <template #tablePanel>
        <assets-list ref="assetsListRef" :info="assetForInfo" @click="onAssetClick" @info="onInfo" @dissmiss-info="dissmissInfo" />
      </template>
    </layout-grid>

    <panel-loading :is-loaded="isLoaded" :progress="progress" />
  </div>
</template>

<script setup>
import LayoutGrid from '../layouts/LayoutGrid.vue';
import PanelList from '../components/PanelList.vue';
import AssetsList from '../components/AssetsList.vue';
import PanelLoading from '../components/PanelLoading.vue';
import RenderView from '../components/RenderView.vue';

import { ref } from 'vue';

const renderViewRef = ref(null);
const assetsListRef = ref(null);

const isLoaded = ref(false);
const progress = ref(0);

const selectedAssets = ref([]);
const assetForInfo = ref(null);

function onRoomClick(item) {
  console.log('onRoomClick', item);
  showInfo(null);
  assetsListRef.value.clear();

  if (item.level === undefined) {
    assetsListRef.value.loadByLevel(item.id);
    return;
  }

  renderViewRef.value.selectObject(item.id);
  assetsListRef.value.loadByRoom(item);
}

function onPlanClick(item) {
  console.log('onPlanClick', item);

  let ids;
  if (item.level === undefined) {
    ids = item.items.map(i => i.id);
  } else {
    ids = [ item.id ];
  }

  renderViewRef.value.setTopView(ids);
}

function onAssetClick(id) {
  renderViewRef.value.selectObject(id);
}

function showInfo(object) {
  assetForInfo.value = object;
}

function onInfo(object) {
  renderViewRef.value.infoObject(object.id);
}

function dissmissInfo() {
  assetForInfo.value = null;
}
</script>
